import { normalizeHexColor } from "../../Objects/Generics/Helps"
import { LEGACY_PUBLIC_MENU_THEME } from "../../PublicMenu/Helpers/PublicMenuTheme"

interface IColorFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  helper: string
  disabled: boolean
}

export const ColorField = ({ label, value, onChange, helper, disabled }: IColorFieldProps) => {
  const normalizedColor = normalizeHexColor(value, LEGACY_PUBLIC_MENU_THEME.primaryColor)

  return (
    <label className="flex flex-wrap items-center gap-3 rounded-lg border border-slate-200 bg-white p-3 shadow-sm transition hover:border-orange-200">
      <div className="min-w-[170px] flex-1">
        <p className="text-[11px] font-black uppercase tracking-[0.18em] text-slate-700">{label}</p>

        <p className="mt-1 text-[11px] text-slate-500">{helper}</p>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <input
          type="color"
          value={normalizedColor}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          className="h-11 w-11 shrink-0 cursor-pointer rounded-lg border border-slate-200 bg-slate-50 p-1 disabled:cursor-not-allowed"
          data-interaction-description-key="interactionDescriptions:components.colorField.colorField.input.input"
        />

        <input
          type="text"
          value={value}
          disabled={disabled}
          maxLength={7}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          className="h-11 w-max rounded-lg border border-slate-200 bg-slate-50 px-2 text-sm font-black uppercase tracking-[0.12em] text-slate-700 outline-none transition focus:border-orange-300 focus:bg-white"
          placeholder="#FFFFFF"
          data-interaction-description-key="interactionDescriptions:components.colorField.colorField.input.ffffff"
        />
      </div>
    </label>
  )
}
